import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Skeleton } from "antd";
import moment from "moment";

import dayjs from "dayjs";

import commentApi from "../../apis/Comment.api";
import orderApi from "../../apis/Order.api";
import settlementApi from "../../apis/Settlement.api";
import summaryApi from "../../apis/Summary.api";
import ApiService from "../../utils/ApiService";

import BannerAlgorithm from "./BannerAlgorithm";

const api = new ApiService();
const BannerNotice = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);

	const [pickDate, setPickDate] = useState(null);

	const [selectMention, setSelectMention] = useState({
		id: 0,
		name: "",
		condition: true,
		count: 0,
	});

	const [statistics, setStatistics] = useState({
		yesterday_total: 0,
		total: 0,
		compare_total: 0,
		compare_count: 0,
		compare_expect: 0,
	});

	useEffect(() => {
		// 날짜 % 4
		const date = new Date();
		// setPickDate(date.getDate() % 3);
		// console.log(date.getDate() % 3);
		// console.log(user.role);
		setPickDate(1); // 0, 1, 2, 3
	}, [user]);

	useEffect(() => {
		// 0 : 유입량, 1: 월매출, 2: 일매출, 3: 댓글
		if (user?.id) {
			if (pickDate === 0) {
				const timer = setTimeout(() => {
					getUserThatTime();
				}, 100);
				return () => clearTimeout(timer);
			} else if (pickDate === 1) {
				const timer = setTimeout(() => {
					getLargestAmount();
				}, 100);
				return () => clearTimeout(timer);
			} else if (pickDate === 2) {
				const timer = setTimeout(() => {
					getStatistics();
				}, 100);
				return () => clearTimeout(timer);
			} else if (pickDate === 3) {
				const timer = setTimeout(() => {
					getCommentList();
				}, 100);
				return () => clearTimeout(timer);
			}

			// getUserThatTime();
			// getLargestAmount();
			// getStatistics();
			// getCommentList();
		}
	}, [pickDate, user]);

	/**
	 * 0) 유입량
	 * @type {(function(): Promise<void>)|*}
	 */
	const getUserThatTime = useCallback(async () => {
		setLoading(true);
		const paramNow = {
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			startDate: moment()
				.subtract(1, "days")
				.startOf("days")
				.format("YYYYMMDDHHmm"),
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
			dateType: "weekly",
		};
		const res = await summaryApi.readDashboardUserThatTime(paramNow);
		if (res.code === 200) {
			let list = res.result?.userSummaryList;
			let now = list[list?.length - 1];
			let before = list[list?.length - 2];

			// 시간 대비 계산 -> ex) 17시면, 전날 유입량 * 17/24
			before = {
				...before,
				inflow_num: (
					(before.inflow_num / 24) *
					Number(dayjs().format("HH"))
				).toFixed(0),
			};

			setSelectMention({
				id: 0,
				name: "inflow",
				condition: Number(now?.inflow_num) > Number(before?.inflow_num),
				count: Number(before?.inflow_num)
					? Math.abs(
							(1 - now?.inflow_num / Number(before?.inflow_num)) * 100
					  ).toFixed(1)
					: 100,
				inflow_now: Number(now?.inflow_num),
				inflow_before: Number(before?.inflow_num),
			});
		}
		setLoading(false);
	}, [user, pickDate]);

	/**
	 * 1) 월매출 비교
	 * @type {(function(): Promise<void>)|*}
	 */
	const getLargestAmount = useCallback(async () => {
		const param = {
			userId: user?.id,
		};
		let bestMonth = {
			settlement_month: moment().format("YYYYMMDDHHmm"),
			total_purchase_amount: 0,
		};
		let thisMonth = {};

		// 정산 내 가장 큰 데이터
		// const resw = await settlementApi.readLargestSettlement(param);
		const res = await settlementApi.readLargestSales(param);
		// 1) 이번달 실시간 데이터 - 쿼리
		const rsp = await api.getProductLinkList(param);
		if (res.code === 200) {
			if (rsp.data.code === 200 && rsp.data.result?.length) {
				const linkList = rsp.data.result.map((link) => link.query);
				const query = linkList.join(",");
				const paramNow = {
					startDate: moment().startOf("months").format("YYYYMMDDHHmm"),
					endDate: moment().endOf("months").format("YYYYMMDDHHmm"),
					queryList: query,
				};

				// 2) 이번달 실시간 데이터 - 통계
				const rspN = await orderApi.orderStatistics(paramNow);
				if (rspN.code === 200) {
					let settleTotal = res.result?.total_purchase_amount;
					let thisTotal = rspN.result?.total_purchase_amount;
					thisMonth = { ...rspN.result };

					if (settleTotal > thisTotal) {
						let year = String(res.result?.year);
						let month = String(res.result?.month);
						bestMonth = {
							settlement_month: moment(year + month, "YYYYMM")
								.endOf("month")
								.format("YYYYMMDDhhmm"),
							...res.result,
						};
					} else {
						bestMonth = {
							...bestMonth,
							...rspN.result,
						};
					}
				}
			}
		}
		let bestMonthBest =
			moment(bestMonth?.settlement_month, "YYYYMMDDhhmm").format("M") ===
			moment().format("M");

		let bestTotalHalf = Math.ceil(bestMonth.total_purchase_amount / 2);

		setSelectMention({
			id: 1,
			name: "monthly",
			condition: !!bestMonthBest && thisMonth.total_purchase_amount > 0,
			count: thisMonth.total_purchase_amount,
			best_amount: bestMonth.total_purchase_amount,
			best_month: moment(bestMonth?.settlement_month, "YYYYMMDDhhmm").format(
				"YY년 M월"
			),
		});

		// console.log({
		// 	id: 1,
		// 	name: "monthly",
		// 	condition: !!bestMonthBest,
		// 	count: bestMonthBest
		// 		? thisMonth.total_purchase_amount
		// 		: bestMonth?.total_purchase_amount,
		// 	best_amount: bestMonth.total_purchase_amount,
		// 	best_month: moment(bestMonth?.settlement_month).format("YY년 M월"),
		// });
	}, [user]);

	/**
	 * 2) 일매출 비교
	 * @type {(function(): Promise<void>)|*}
	 */
	const getStatistics = useCallback(async () => {
		setLoading(true);
		const param = {
			userId: user?.id,
		};
		const res = await api.getProductLinkList(param);
		if (res.data.code === 200 && res.data.result?.length) {
			const linkList = res.data.result.map((link) => link.query);
			const query = linkList.join(",");

			const paramBefore = {
				startDate: moment()
					.subtract(1, "days")
					.startOf("days")
					.format("YYYYMMDDHHmm"),
				endDate: moment()
					.subtract(1, "days")
					.endOf("days")
					.format("YYYYMMDDHHmm"),
				queryList: query,
			};
			const paramNow = {
				startDate: moment().startOf("days").format("YYYYMMDDHHmm"),
				endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
				queryList: query,
			};

			const resB = await orderApi.orderStatistics(paramBefore);
			const resN = await orderApi.orderStatistics(paramNow);

			let beforeValue = {
				total: 0,
				count: 0,
				expect: 0,
				combine: 0,
			};
			let nowValue = {
				total: 0,
				count: 0,
				expect: 0,
				combine: 0,
			};

			if (resB.code === 200) {
				const before = resB.result;

				beforeValue = {
					total: before?.total_purchase_amount ?? 0,
					count: before?.purchases_num ?? 0,
					expect: before?.expected_profit_amount ?? 0,
					combine: before?.combined_amount ?? 0,
				};
			}
			if (resN.code === 200) {
				const now = resN.result;
				nowValue = {
					total: now?.total_purchase_amount ?? 0,
					count: now?.purchases_num ?? 0,
					expect: now?.expected_profit_amount ?? 0,
					combine: now?.combined_amount ?? 0,
				};
			}

			setStatistics({
				yesterday_total: beforeValue?.total,
				total: nowValue?.total,
				compare_total: nowValue?.total - beforeValue?.total,
				compare_count: nowValue?.count - beforeValue?.count,
				compare_expect: nowValue?.expect - beforeValue?.expect,
			});

			if (nowValue?.total === 0 && beforeValue?.total === 0) {
				setSelectMention({
					id: 2,
					name: "daily_sales",
					condition: false,
					count: 0,
				});
			} else {
				setSelectMention({
					id: 2,
					name: "daily_sales",
					condition: nowValue?.total > beforeValue?.total,
					count:
						beforeValue?.total !== 0
							? Math.abs(
									(1 - nowValue?.total / beforeValue?.total) * 100
							  ).toFixed(1)
							: 100,
					compare_total: nowValue?.total - beforeValue?.total,
					today: nowValue?.total,
					yesterday: beforeValue?.total,
				});
			}
		} else {
			setSelectMention({
				id: 2,
				name: "daily_sales",
				condition: 0,
				count: 0,
			});
		}
		setLoading(false);
	}, [user]);

	/**
	 * 3) 응답하지 않은 댓글
	 * @type {(function(): Promise<void>)|*}
	 */
	const getCommentList = useCallback(async () => {
		setLoading(true);
		const param = {
			offset: 0,
			pageSize: 1,
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			answerStatus: 1,
			category: "all",
			searchWord: "",
		};
		const res = await commentApi.adminReadComment(param);
		if (res.code === 200) {
			setSelectMention({
				id: 3,
				name: "un_answer_comment",
				condition: false,
				count: res.result.totalCnt,
			});
		} else {
			setSelectMention({
				id: 3,
				name: "un_answer_comment",
				condition: false,
				count: 0,
			});
		}
		setLoading(false);
	}, []);

	if (loading) {
		return (
			<div className={`dashboard-component`}>
				<div className={`dashboard-banner-div`}>
					<div style={{ display: "flex", gap: "1em", width: "100%" }}>
						<Skeleton.Avatar
							loading={loading}
							active={loading}
							size={"large"}
							block={true}
							style={{
								width: "3em",
								height: "3em",
							}}
						/>
						<Skeleton.Button
							loading={loading}
							active={loading}
							size={"large"}
							block={true}
							style={{
								height: "3em",
								width: "100%",
							}}
							title={null}
						/>
					</div>
				</div>
			</div>
		);
	} else {
		return <BannerAlgorithm mention={selectMention} />;
	}
};
export default BannerNotice;
